/**
 * QEVIQ storefront stability
 * - Open normal page loads/navigations at the top (no browser scroll restoration)
 * - Preserve intentional URL hash / same-page CTA scrolling
 * - Skip forced resets in Shopify theme editor
 * - Clear stuck body scroll locks after overlays
 */
(function () {
  if (window.__qeviqMobileStabilityBound) return;
  window.__qeviqMobileStabilityBound = true;

  var LOCK_CLASSES = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop',
    'qeviq-loox-scroll-lock',
    'loox-overlay-is-active',
    'qcr-modal-open',
    'qeviq-media-modal-open',
  ];

  var BODY_STYLE_PROPS = ['overflow', 'position', 'top', 'left', 'right', 'width', 'paddingRight', 'touchAction'];

  function inDesignMode() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function hasOpenOverlay() {
    return !!document.querySelector(
      'cart-drawer.active, details.menu-opening, .menu-drawer-container.menu-opening, header-drawer details[open].menu-opening, .loox-overlay, [id^="loox_overlay"], #looxModalFrame, iframe#looxModalFrame, .qcr-modal.is-open, .qeviq-pdp-media-modal.is-open, .product-media-modal[open]'
    );
  }

  function clearStuckLocks(force) {
    if (!force && hasOpenOverlay()) return;
    if (force && hasOpenOverlay()) return;

    LOCK_CLASSES.forEach(function (cls) {
      document.documentElement.classList.remove(cls);
      document.body.classList.remove(cls);
    });

    BODY_STYLE_PROPS.forEach(function (prop) {
      document.body.style[prop] = '';
      document.documentElement.style[prop] = '';
    });
  }

  function isIntentionalAnchor(hash) {
    if (!hash || hash === '#') return false;
    if (hash.indexOf('#loox') === 0) return false;
    if (hash === '#MainContent') return false;
    return /^#[A-Za-z][\w:-]*$/.test(hash);
  }

  function ensureManualScrollRestoration() {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }

  function scrollPageToTop() {
    if (inDesignMode()) return;

    var hash = window.location.hash || '';

    if (hash.indexOf('#loox') === 0) {
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } catch (e) {}
      hash = '';
    }

    if (isIntentionalAnchor(hash)) return;

    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }

  function onStorefrontReady() {
    ensureManualScrollRestoration();
    clearStuckLocks(false);
    scrollPageToTop();
  }

  ensureManualScrollRestoration();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onStorefrontReady, { once: true });
  } else {
    onStorefrontReady();
  }

  window.addEventListener(
    'load',
    function () {
      onStorefrontReady();
      /* One frame later catches late browser restoration without timeouts/loops. */
      window.requestAnimationFrame(scrollPageToTop);
    },
    { once: true }
  );

  window.addEventListener('pageshow', function () {
    onStorefrontReady();
  });

  document.addEventListener('shopify:section:load', function () {
    clearStuckLocks(false);
  });

  var unlockTimer = null;
  function scheduleUnlockCleanup() {
    window.clearTimeout(unlockTimer);
    unlockTimer = window.setTimeout(function () {
      if (!hasOpenOverlay()) clearStuckLocks(false);
    }, 420);
  }

  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (
        t.closest(
          'cart-drawer, .cart-drawer__close, .drawer__close, header-drawer, menu-drawer, .header__icon--menu, .menu-drawer__close-button, .cart-count-bubble, #cart-icon-bubble'
        )
      ) {
        scheduleUnlockCleanup();
      }
    },
    true
  );
})();
